/**
 * The month grid on the occasion form.
 *
 * A calendar rather than the browser's own date input, and not only because
 * that one looks like a browser. This date is not just a date: once it is
 * chosen we know the last day an order can be placed and still be altered in
 * time for it, and that belongs drawn on the calendar beside the day itself
 * rather than left for somebody to count backwards.
 *
 * The native input stays in the page, hidden. It is still what the form reads
 * and what a screen reader or a keyboard gets, and if this script never arrives
 * the field simply works the way it always did. Nothing here is the only way to
 * pick a date.
 */
(function () {
  'use strict';

  /* Trade knowledge, not arithmetic: a suit has to arrive and then be taken up,
     and the second half is the one nobody counts. Matches the server's own
     defaults in services/occasionOrders. */
  var DELIVERY_DAYS = 3;
  var ALTERATION_DAYS = 10;
  var DAY = 86400000;

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'];
  var DOW = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  var iso = function (d) { return d.toISOString().slice(0, 10); };
  var midnight = function (d) { return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())); };

  function build(input, host) {
    var today = midnight(new Date());
    var chosen = input.value ? new Date(input.value + 'T00:00:00Z') : null;
    var view = new Date(chosen && !isNaN(chosen) ? chosen : today);
    view.setUTCDate(1);

    function orderBy(date) {
      return new Date(date.getTime() - (DELIVERY_DAYS + ALTERATION_DAYS) * DAY);
    }

    function draw() {
      host.innerHTML = '';

      var head = el('div', 'tc-cal__head');
      var back = el('button', 'tc-cal__nav', '‹');
      back.type = 'button';
      back.setAttribute('aria-label', 'Previous month');
      back.addEventListener('click', function () { view.setUTCMonth(view.getUTCMonth() - 1); draw(); });

      var on = el('button', 'tc-cal__nav', '›');
      on.type = 'button';
      on.setAttribute('aria-label', 'Next month');
      on.addEventListener('click', function () { view.setUTCMonth(view.getUTCMonth() + 1); draw(); });

      head.appendChild(back);
      head.appendChild(el('span', 'tc-cal__month',
        MONTHS[view.getUTCMonth()] + ' ' + view.getUTCFullYear()));
      head.appendChild(on);
      host.appendChild(head);

      var grid = el('div', 'tc-cal__grid');
      DOW.forEach(function (d) { grid.appendChild(el('span', 'tc-cal__dow', d)); });

      /* Monday-first, because this is a British shop and a wedding is on a
         Saturday — which belongs at the end of the row, not the start. */
      var first = new Date(Date.UTC(view.getUTCFullYear(), view.getUTCMonth(), 1));
      var lead = (first.getUTCDay() + 6) % 7;
      for (var i = 0; i < lead; i++) grid.appendChild(el('span', 'tc-cal__pad'));

      var days = new Date(Date.UTC(view.getUTCFullYear(), view.getUTCMonth() + 1, 0)).getUTCDate();
      var deadline = chosen && !isNaN(chosen) ? orderBy(chosen) : null;

      for (var day = 1; day <= days; day++) {
        var date = new Date(Date.UTC(view.getUTCFullYear(), view.getUTCMonth(), day));
        var cell = el('button', 'tc-cal__day', String(day));
        cell.type = 'button';

        if (date.getTime() < today.getTime()) {
          cell.disabled = true;
          cell.className += ' is-past';
        }
        if (chosen && !isNaN(chosen) && date.getTime() === chosen.getTime()) {
          cell.className += ' is-on';
          cell.setAttribute('aria-current', 'date');
        }
        if (date.getTime() === today.getTime()) cell.className += ' is-today';
        /* The day everything has to be ordered by, marked so the gap between
           it and the wedding is a thing you can see rather than work out. */
        if (deadline && date.getTime() === midnight(deadline).getTime()) {
          cell.className += ' is-deadline';
          cell.title = 'Order by this day to have it altered in time';
        }

        (function (picked) {
          cell.addEventListener('click', function () {
            chosen = picked;
            input.value = iso(picked);
            input.dispatchEvent(new Event('change', { bubbles: true }));
            draw();
          });
        })(date);

        grid.appendChild(cell);
      }
      host.appendChild(grid);

      var note = el('p', 'tc-cal__note');
      if (chosen && !isNaN(chosen)) {
        var by = orderBy(chosen);
        if (by.getTime() < today.getTime()) {
          note.className += ' is-warn';
          note.textContent = 'That is soon — tell us and we will say what can still be done in time.';
        } else {
          note.textContent = 'Order by ' + by.getUTCDate() + ' ' + MONTHS[by.getUTCMonth()]
            + ' to allow for delivery and a tailor.';
        }
      } else {
        note.textContent = 'Pick the day and we will work out the last date to order.';
      }
      host.appendChild(note);
    }

    draw();
    host.hidden = false;
    input.classList.add('tc-field__in--hidden');
  }

  function boot(scope) {
    var inputs = (scope || document).querySelectorAll('[data-tc-occ-date]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var host = input.parentNode && input.parentNode.querySelector('[data-tc-cal]');
      if (host && !host.__tcCal) { host.__tcCal = true; build(input, host); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
